export class WebEventoDocumentoEntidade {
	public OID_EVENTO_DOCUMENTO: number;
	public OID_EVENTO: number;
	public TXT_TITULO: string;
	public TXT_NOME_FISICO: string;
}
